import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/posts`)
      .then((r) => r.json())
      .then((d) => setPosts(d.posts || []))
      .catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  const visible = posts.slice(0, 3);

  return (
    <section id="blog" data-testid="blog-section" className="border-b border-[#2A241F] py-12 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="section-kicker">Cose utili da sapere</p>
          <h2 className="mt-4 font-heading text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#FAF7F2] sm:text-4xl lg:text-5xl">
            Scritto semplice, per proprietari
          </h2>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-[#C4BBB0]">
            Niente paroloni: quello che serve sapere per affittare bene casa tua, spiegato come lo spiegherei a un amico.
          </p>
        </Reveal>

        <div className="mt-12 grid items-start gap-4 lg:grid-cols-3">
          {visible.map((post, i) => {
            const open = openId === post.id;
            const readingTime = Math.max(1, Math.round(post.paragraphs.join(" ").split(/\s+/).length / 200));
            return (
              <Reveal key={post.id} delay={i * 0.06}>
                <div data-testid={`blog-post-${i + 1}`} className={`border transition-colors duration-300 ${open ? "border-[#E05A2C] bg-[#16110E]" : "border-[#2A241F] hover:border-[#E05A2C]"}`}>
                  <button
                    data-testid={`blog-toggle-${i + 1}`}
                    onClick={() => setOpenId(open ? null : post.id)}
                    aria-expanded={open}
                    className="group flex w-full flex-col p-7 text-left"
                  >
                    <span className="font-mono text-xs uppercase tracking-widest text-[#A89F91]">
                      <span className="text-[#E05A2C]">{post.category}</span> · {post.date_label} · {readingTime} min
                    </span>
                    <span className="mt-3 block font-heading text-lg font-black uppercase leading-tight tracking-tight text-[#FAF7F2] transition-colors duration-300 group-hover:text-[#E05A2C]">
                      {post.title}
                    </span>
                    <span className="mt-3 block text-sm leading-relaxed text-[#A89F91]">{post.excerpt}</span>
                    <span className="mt-5 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#A89F91] transition-colors duration-300 group-hover:text-[#E05A2C]">
                      {open ? "Chiudi" : "Leggi"}
                      {open ? <Minus className="h-4 w-4 text-[#E05A2C]" /> : <Plus className="h-4 w-4" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <div data-testid={`blog-content-${i + 1}`} className="space-y-4 border-t border-[#2A241F] px-7 pb-7 pt-6">
                          {post.paragraphs.map((p) => (
                            <p key={p.slice(0, 24)} className="text-sm leading-relaxed text-[#C4BBB0]">{p}</p>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
